import { Controller } from "@hotwired/stimulus";

// 点击项目行展开/折叠对应的 MarkTask 子行
export default class extends Controller {
  static values = { target: String };

  toggle(event) {
    // 若点击的是链接，不触发折叠
    if (event.target.closest("a")) return;

    const group = this.targetValue;
    const rows = document.querySelectorAll(`[data-task-group="${group}"]`);
    const chevron = document.getElementById(
      `chevron-${group.replace("project-tasks-", "")}`,
    );

    rows.forEach((row) => row.classList.toggle("hidden"));

    if (chevron) {
      chevron.classList.toggle("rotate-90");
    }
  }
}
